<template>
    <div>
        <webix-ui :config="config" v-model="session_data"></webix-ui>
        <div id="sessionsPaging"></div>
    </div>
</template>

<script>
import _ from 'lodash';
import { facilityAdminMethods, facilityAdminState} from "@/state/helpers"
import dateMixin from '@/mixins/dateMixin.js'
export default {
    mixins: [dateMixin],
    data:() => ({
        
    }),
    props:{
        sessions:{}
    },
    computed:{
        ...facilityAdminState,
        session_data(){
            return _.cloneDeep(this.sessions);
        },
        config(){
            return {
                id: 'sessionsTable',
                view: 'datatable',
                css: "datatableUsers webix_header_border webix_data_border",
                autoheight: true,
                //hover: "datatableHover",
                minHeight:50,
                minColumnWidth: 120,
                scrollY:false,
                scrollX:true,
                resizeColumn: true,
                select: false,
                pager:{
                    template:"{common.prev()} {common.pages()} {common.next()}",
                    container:"sessionsPaging",
                    size:15,
                    group:5
                },
                columns: this.columns,
                on:{
                    /*onSelectChange(){
                        var el = this.$scope.$parent;
                        let item = this.getSelectedId();
                        el.$emit('selectedRow', item);
                    }*/
                },
                onClick:{
                    //eslint-disable-next-line
                    select_action(event, cell, target){
                        var el = this.$scope.$parent;
                        el.$emit('selectedRow', cell.row);
                    },
                    //eslint-disable-next-line
                    delete_action(event, cell, target){
                        var el = this.$scope.$parent;
                        el.showSessionDeletePrompt(cell.row)
                    },
                }
            };
        },
        columns(){
            let el = this;
            return [
                {
                    id: 'actions', header: 'Actions',
                    template(){
                        return "<div class='tableIcons'><i title='View Audit' class='select_action iconHover fas fa-binoculars'></i>&nbsp;&nbsp;<i class=' delete_action fas fa-trash'></i></div>"
                    }
                },
                { id: 'active', header: 'Audit In Progress', fillspace: 0.4, 
                    template(obj){
                        if(obj.active){
                            return 'Yes'
                        }
                        else{
                            return 'No'
                        }
                    }
                },
                { id: 'start_date', header: 'Start Date', fillspace: 0.3, 
                    format(value){
                        let date = el.getDate(value);
                        return `<div class="select_action">${date}</div>`
                    }
                },
                { id: 'end_date', header: 'End Date', fillspace: 0.3,
                    format(value){
                        if(!value){
                            return 'N/A'
                        }
                        else{
                            let date = el.getDate(value);
                            return `<div class="select_action">${date}</div>`
                        }
                    }
                },
                { id: 'compliant', header: 'Compliant', fillspace: 0.4, 
                    template(obj){
                        if(obj.compliant){
                            return "<div class='tableIcons'><i title='Compliant' class='compliant fas fa-check-circle'></i></div>"
                        }
                        else{
                            return "<div class='tableIcons'><i title='Non Compliant' class='nonCompliant fas fa-times-circle'></i></div>"
                        }
                    }
                },
                { id: 'compliance_percentage', header: 'Compliance %', fillspace: 0.4,
                    format(value){
                        return `<div>${value}%</div>`
                    }
                },
                { id: 'created_by_user_name', header: 'Created By', fillspace: 0.4},
                { id: 'updated_by_user_name', header: 'Last Updated By', fillspace: 0.4},
            ];

        }
    },
    methods:{
        ...facilityAdminMethods,
        showSessionDeletePrompt(session_id){
            this.$swal.fire({
                title: "Delete Audit Session?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes"
            }).then(result => {
                if (result.value) {
                    this.deleteAuditSession(session_id).then(()=>{
                        this.getClientAudit(this.selected_audit);
                    })
                }
            });
        },
    },
    mounted(){
        window.session_inst = this;
    },
    beforeDestroy(){
        window.session_inst = undefined;
    }
}
</script>

<style>
.tableIcons {
    cursor: pointer;
    font-size: 1.5rem;
    text-align: center;
}
.nonCompliant {
    color: red;
}
.compliant {
    color: green;
}
.iconHover:hover{
    color: var(--bs-danger);
    cursor: pointer;
}
</style>